'use strict';
module.exports = function(app) {
    require('./js/controller/biddingProduct.controller.js')(app);
    require('./js/controller/auction_setting.controller.js')(app);
    require('./js/directive/increase_bid_input.directive.js')(app);
    require('./js/service/socket.service.js')(app);
    require('./js/service/admin.service.js')(app);
    require('./scss/bidding_product.scss');
};



/*****************
 ** WEBPACK FOOTER
 ** ./bidding_product/index.js
 ** module id = 51
 ** module chunks = 0
 **/